/* cart-drawer.js */
document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.getElementById("CustomCartDrawer");
  if (!drawer) return;

  const contentHolder = drawer.querySelector("[data-cart-items]");
  const countElements = document.querySelectorAll(
    "[data-cart-count], .cart-link__bubble-num",
  );
  const totalElements = document.querySelectorAll("[data-cart-total]");
  const emptyMessage = drawer.querySelector("[data-cart-empty]");
  const formArea = document.getElementById("CustomCartDrawerForm");

  // Progress Bar Elements
  const progContainer = drawer.querySelector("[data-progress-bar]");
  const progText = drawer.querySelector("[data-progress-text]");
  const progFill = drawer.querySelector("[data-progress-fill]");
  const milestoneEls = drawer.querySelectorAll("[data-milestone]");

  // Footer Elements
  const footerUnlockBadge = drawer.querySelector("[data-footer-unlock-badge]");
  const footerUnlockedDiscount = drawer.querySelector(
    "[data-footer-unlocked-discount]",
  );

  const settings = window.customCartSettings || {};
  let isDrawerOpen = false;
  let isUpdating = false;
  let lastCartState = "";

  const formatMoney = (cents) => {
    // Basic fallback, can hook into theme.Currency later if needed
    let moneyString = "£" + (cents / 100).toFixed(2);
    if (
      window.theme &&
      window.theme.settings &&
      window.theme.settings.moneyFormat
    ) {
      moneyString = window.theme.settings.moneyFormat
        .replace("{{amount}}", (cents / 100).toFixed(2))
        .replace("{{amount_no_decimals}}", Math.round(cents / 100));
      // Also handle shopify's standard formats
      moneyString = moneyString.replace(
        /\{\{\s*amount\s*\}\}/g,
        (cents / 100).toFixed(2),
      );
    }
    return moneyString;
  };

  const openDrawer = () => {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open");
    isDrawerOpen = true;
    updateCartDOM();
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
    isDrawerOpen = false;
  };

  // Bind Openers
  document
    .querySelectorAll('a[href="/cart"], .js-drawer-open-cart')
    .forEach((el) => {
      el.addEventListener("click", function (e) {
        if (!e.target.closest(".cart__checkout")) {
          e.preventDefault();
          openDrawer();
        }
      });
    });

  // Bind Closers
  drawer.querySelectorAll("[data-cart-close]").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      closeDrawer();
    });
  });

  // Handle outside click
  document.addEventListener("click", function (e) {
    if (isDrawerOpen && e.target === drawer) {
      closeDrawer();
    }
  });

  const updateCartDOM = (force = false) => {
    if (isUpdating && !force) return Promise.resolve();
    
    return fetch("/cart.js")
      .then((res) => res.json())
      .then(async (cart) => {
        // Ensure settings and map exist
        if (!window.customCartSettings) window.customCartSettings = {};
        if (!window.customCartSettings.compareAtMap) window.customCartSettings.compareAtMap = {};
        const settings = window.customCartSettings;

        // Fetch missing compare-at prices for items not in the map
        const missingItems = cart.items.filter(item => !settings.compareAtMap[item.variant_id]);
        if (missingItems.length > 0) {
          const handles = [...new Set(missingItems.map(i => i.handle))];
          await Promise.all(handles.map(handle => 
            fetch(`/products/${handle}.js`)
              .then(r => r.json())
              .then(p => {
                p.variants.forEach(v => {
                  settings.compareAtMap[v.id] = v.compare_at_price || v.price;
                });
              })
              .catch(err => console.warn(`Could not fetch data for ${handle}:`, err))
          ));
        }

        renderCart(cart);
      })
      .catch((err) => console.error("Error fetching cart:", err));
  };

  const changeItemQuantity = (key, quantity) => {
    if (isUpdating) return;
    isUpdating = true;
    drawer.classList.add('is-loading');

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
      }),
    })
      .then((res) => res.json())
      .then((cart) => {
        renderCart(cart);
        isUpdating = false;
        drawer.classList.remove('is-loading');
      })
      .catch((err) => {
        console.error("Error updating cart:", err);
        isUpdating = false;
        drawer.classList.remove('is-loading');
      });
  };

  const renderCart = (cart) => {
    // State Check: Only re-render if something actually changed
    const currentState = JSON.stringify({
        count: cart.item_count,
        total: cart.total_price,
        items: cart.items.map(i => `${i.key}-${i.quantity}`)
    });
    
    if (currentState === lastCartState) {
        console.log("Cart state identical, skipping render.");
        return;
    }
    lastCartState = currentState;

    console.log("Rendering cart. Items:", cart.item_count);
    if (cart.item_count === 0) {
      drawer.classList.add("cart-is-empty");
    } else {
      drawer.classList.remove("cart-is-empty");
    }

    // Update Counts
    countElements.forEach((el) => {
      el.textContent = cart.item_count;
      if (
        el.classList.contains("cart-link__bubble-num") &&
        cart.item_count === 0
      ) {
        el.parentElement.classList.add("hidden"); // Hide bubble if 0
      } else if (el.classList.contains("cart-link__bubble-num")) {
        el.parentElement.classList.remove("hidden");
      }
    });

    // Update Totals
    totalElements.forEach(
      (el) => (el.textContent = formatMoney(cart.total_price)),
    );

    if (cart.item_count > 0) {
      let html = "";
      let activeDiscount = 0;
      let calculatedTotalSavings = 0;
      let totalMilestoneSavings = 0;

      // Logic for milestones calculation based on items count
      if (settings.milestones) {
        let maxItems = 1;
        let currentItems = cart.item_count;
        let nextMilestone = null;

        settings.milestones.forEach((m, idx) => {
          if (m.items > maxItems) maxItems = m.items;
          let mEl = drawer.querySelector(`[data-milestone="${idx + 1}"]`);
          if (mEl) {
            if (currentItems >= m.items) {
              mEl.classList.add("is-active");
              activeDiscount = m.discount;
            } else {
              mEl.classList.remove("is-active");
              if (!nextMilestone) nextMilestone = m;
            }
          }
        });

        if (progFill) {
          let pct = 0;
          if (currentItems > 0) {
            let prevItems = 0;
            let currentRangeIndex = -1;

            for (let i = 0; i < settings.milestones.length; i++) {
              if (currentItems < settings.milestones[i].items) {
                currentRangeIndex = i;
                break;
              }
              prevItems = settings.milestones[i].items;
            }

            if (currentRangeIndex === -1) {
              pct = 100;
            } else {
              let milestonePositions = [0, 33.33, 66.66, 100];
              if (currentItems >= settings.milestones[settings.milestones.length - 1].items) {
                pct = 100;
              } else {
                let mStartIdx = 0;
                for (let i = 0; i < settings.milestones.length; i++) {
                  if (currentItems >= settings.milestones[i].items) {
                    mStartIdx = i;
                  } else {
                    break;
                  }
                }
                
                let startPos = milestonePositions[mStartIdx];
                let endPos = milestonePositions[mStartIdx + 1];
                let startItems = settings.milestones[mStartIdx].items;
                let endItems = settings.milestones[mStartIdx + 1].items;
                
                let itemProgress = (currentItems - startItems) / (endItems - startItems);
                pct = startPos + (itemProgress * (endPos - startPos));
              }
            }
          }
          progFill.style.width = pct + "%";
        }

        if (progText) {
          if (!nextMilestone) {
            progText.innerHTML = `<strong>Congratulations!</strong> You've unlocked the maximum discount.`;
          } else {
            let diff = nextMilestone.items - currentItems;
            let rawMsg =
              settings.progressMessage ||
              "You're [items_needed] product away from an extra [discount]% discount";
            progText.innerHTML = rawMsg
              .replace("[items_needed]", `<strong>${diff}</strong>`)
              .replace(
                "[discount]",
                `<strong>${nextMilestone.discount}</strong>`,
              );
          }
        }
      }

      // Update Footer Badge
      if (
        footerUnlockBadge &&
        settings.flags &&
        settings.flags.unlockBadgeEnable
      ) {
        if (activeDiscount > 0) {
          footerUnlockBadge.style.display = "flex";
             footerUnlockBadge.querySelector('span').innerHTML = `<strong>${activeDiscount}% EXTRA OFF</strong>`;
        } else {
          footerUnlockBadge.style.display = "none";
        }
      }

      // Render Items
      cart.items.forEach((item) => {
        let optionsHtml = "";
        if (item.variant_options && item.variant_options.length > 0) {
          item.variant_options.forEach((opt, i) => {
            if (opt !== "Default Title") {
              let label = i === 0 ? "Color" : i === 1 ? "Size" : "Option";
              optionsHtml += `<div>${label}: ${opt}</div>`;
            }
          });
        }

        let priceHtml = "";
        let originalPrice = item.original_line_price || item.original_price * item.quantity;
        let finalPrice = item.final_line_price || item.final_price * item.quantity;
        
        // Use compare_at_price from map if available
        let unitCompareAt = Number((settings.compareAtMap && settings.compareAtMap[item.variant_id]) || item.original_price) || 0;
        let compareAt = unitCompareAt * item.quantity;
        
        if (compareAt <= originalPrice) {
          compareAt = originalPrice;
        }

        let itemSavings = 0;

        // NEW LOGIC FIX: Check if Shopify applied a line-item discount
        if (originalPrice > finalPrice) {
          itemSavings = originalPrice - finalPrice;
        } 
        // If Shopify applied it at the cart level instead, we calculate it visually
        else if (activeDiscount > 0) {
          // CONSISTENT CALCULATION: Sum these up precisely for the total
          itemSavings = Math.round((originalPrice * Number(activeDiscount || 0)) / 100);
          finalPrice = originalPrice - itemSavings;
        }

        totalMilestoneSavings += itemSavings;

        // Total item savings = Retail discount + Milestone/Cart discount
        let retailSaving = Math.max(0, compareAt - originalPrice);
        let totalItemSavings = itemSavings + retailSaving;

        calculatedTotalSavings += totalItemSavings;

        // Render visual pricing based on the savings math
        if (totalItemSavings > 0) {
           priceHtml = `
             <div class="custom-cart-drawer__price-row">
               ${retailSaving > 0 || activeDiscount > 0 ? `<div class="custom-cart-drawer__price-original">${formatMoney(compareAt)}</div>` : ''}
               <div class="custom-cart-drawer__price-final">${formatMoney(finalPrice)}</div>
             </div>
             ${settings.flags && settings.flags.savingsEnable ? `<div class="custom-cart-drawer__savings" style="color: ${settings.colors.savings};">(Save ${formatMoney(totalItemSavings)})</div>` : ''}
           `;
        } else {
           priceHtml = `
             <div class="custom-cart-drawer__price-row">
               <div class="custom-cart-drawer__price-final">${formatMoney(finalPrice)}</div>
             </div>`;
        }

        let badgeHtml = "";

        let imgUrl = item.image || item.featured_image.url || "";
        if (imgUrl) imgUrl = imgUrl.replace(/(\.[^.]*)$/, "_200x$1"); // small thumb size

        html += `
          <div class="custom-cart-drawer__item" data-key="${item.key}">
            <img class="custom-cart-drawer__item-image" src="${imgUrl}" alt="${item.product_title}" width="85" height="85" loading="lazy" />
            
            <div class="custom-cart-drawer__item-details">
              <button type="button" class="custom-cart-drawer__item-remove" data-remove="${item.key}" aria-label="Remove">
                <svg viewBox="0 0 24 24" fill="none" style="width:16px;height:16px;" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
              </button>
              
              <div class="custom-cart-drawer__item-title">${item.product_title}</div>
              <div class="custom-cart-drawer__item-options">${optionsHtml}</div>
              
              <div class="custom-cart-drawer__bottom-row">
                <div class="custom-cart-drawer__qty">
                  <button type="button" data-qty-change="minus" data-key="${item.key}">-</button>
                  <input type="number" value="${item.quantity}" min="0" readonly />
                  <button type="button" data-qty-change="plus" data-key="${item.key}">+</button>
                </div>
                
                <div class="custom-cart-drawer__item-price-wrapper">
                  ${priceHtml}
                </div>
              </div>
              
              ${badgeHtml}
            </div>
          </div>
        `;
      });

      // Update DOM
      contentHolder.innerHTML = html;

      // Update Footer Discounts Row
      const discountsSection = drawer.querySelector('[data-cart-discounts-section]');
      const discountTotal = drawer.querySelector('[data-cart-discount-total]');
      if (discountsSection) {
         let subtotalDiscount = 0;
         if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            cart.cart_level_discount_applications.forEach(d => {
               subtotalDiscount += d.total_allocated_amount;
            });
         }
         
         // Use the sum of item-level milestone discounts accumulated above
         let milestoneDiscountAmount = totalMilestoneSavings;

         let displaySavings = Math.max(Number(subtotalDiscount) || 0, Number(milestoneDiscountAmount) || 0);

         if (displaySavings > 0) {
            discountsSection.style.display = 'block';
            if (discountTotal) discountTotal.textContent = '- ' + formatMoney(displaySavings);
            if (footerUnlockBadge && activeDiscount > 0) {
               footerUnlockBadge.style.display = 'flex';
               const badgeSpan = footerUnlockBadge.querySelector('span');
               if (badgeSpan) {
                  badgeSpan.innerHTML = `<strong>${activeDiscount}% EXTRA OFF</strong>`;
               }
            }
         } else {
            discountsSection.style.display = 'none';
            if (footerUnlockBadge) footerUnlockBadge.style.display = 'none';
         }
      }
    }
  };

  // Bind Events using PointerDown for instant response on iPhone
  // Use delegation on the static contentHolder
  contentHolder.addEventListener("pointerdown", function (e) {
    const qtyBtn = e.target.closest("[data-qty-change]");
    const removeBtn = e.target.closest("[data-remove]");

    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.getAttribute("data-key");
      const isPlus = qtyBtn.getAttribute("data-qty-change") === "plus";
      const input = qtyBtn.parentElement.querySelector("input");
      const currentQty = parseInt(input.value);
      const newQty = isPlus ? currentQty + 1 : currentQty - 1;
      changeItemQuantity(key, Math.max(0, newQty));
    } else if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.getAttribute("data-remove");
      changeItemQuantity(key, 0);
    }
  });

  // Listen for theme's native add-to-cart AJAX event
  ["ajaxProduct:added", "cart:updated", "theme:cart:changed"].forEach(event => {
    document.addEventListener(event, function (e) {
      try {
        console.log(`Event detected: ${event}`);
        // Small delay to ensure Shopify backend has processed the addition fully
        setTimeout(() => {
          updateCartDOM(true).then(() => {
            openDrawer();
          });
        }, 100);
      } catch (err) {
        console.warn(`Error in ${event} listener:`, err);
      }
    });
  });

  // Handle clicks on empty cart recommended items Add buttons manually
  document.addEventListener("click", function (e) {
    if (e.target.matches('.custom-cart-drawer__rec-add-btn')) {
      e.preventDefault();
      
      const btn = e.target;
      const container = btn.closest('.custom-cart-drawer__rec-form');
      if (!container) return;
      
      let idInput;
      // If there is a select dropdown (variants), use it. Otherwise use the hidden input
      const select = container.querySelector('select[name="id"]');
      if (select) {
         idInput = select;
      } else {
         idInput = container.querySelector('input[name="id"]');
      }
      
      if (!idInput) return;
      
      btn.disabled = true;
      btn.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
           items: [{
              id: parseInt(idInput.value),
              quantity: 1
           }]
        }),
      })
        .then((res) => {
          if (!res.ok) {
            return res.json().then(json => { throw new Error(json.description || "Error adding to cart") });
          }
          return res.json();
        })
        .then((data) => {
          btn.disabled = false;
          btn.textContent = "Add";
          updateCartDOM(true).then(() => {
             openDrawer();
          });
        })
        .catch((err) => {
          console.error("Error adding to cart:", err);
          alert(err.message);
          btn.disabled = false;
          btn.textContent = "Add";
        });
    }
  });

  // Initial load check if needed
  updateCartDOM();
});

(function() {
  const STORAGE_KEY = 'cartReservationExpiry';
  const DURATION = 15 * 60 * 1000; // 15 minutes

  function getExpiryTime() {
    let expiry = sessionStorage.getItem(STORAGE_KEY);
    if (!expiry) {
      expiry = Date.now() + DURATION;
      sessionStorage.setItem(STORAGE_KEY, expiry);
    }
    return parseInt(expiry);
  }

  function updateTimer() {
    const bannerEl = document.querySelector('.custom-cart-drawer__urgency-banner--timer');
    if (!bannerEl) return;

    const itemCount = parseInt(document.querySelector('[data-cart-count]')?.textContent || '0');

    if (itemCount === 0) {
      sessionStorage.removeItem(STORAGE_KEY);
      bannerEl.innerHTML = 'Items held for <span data-cart-timer>15:00</span> minutes';
      setTimeout(updateTimer, 1000);
      return;
    }

    const expiry = getExpiryTime();
    const remaining = expiry - Date.now();

    if (remaining <= 0) {
      bannerEl.innerHTML = 'Reservation expired — items may sell out';
      setTimeout(updateTimer, 1000);
      return;
    }

    let timerEl = document.querySelector('[data-cart-timer]');
    if (!timerEl) {
      bannerEl.innerHTML = 'Items held for <span data-cart-timer>15:00</span> minutes';
      timerEl = document.querySelector('[data-cart-timer]');
    }

    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    timerEl.textContent = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    setTimeout(updateTimer, 1000);
  }

  document.addEventListener('DOMContentLoaded', updateTimer);
})();